import { render, staticRenderFns } from "./taskMerge.vue?vue&type=template&id=bf114f04&scoped=true&"
import script from "./taskMerge.vue?vue&type=script&lang=js&"
export * from "./taskMerge.vue?vue&type=script&lang=js&"
import style0 from "./taskMerge.vue?vue&type=style&index=0&id=bf114f04&scoped=true&lang=scss&"
import style1 from "./taskMerge.vue?vue&type=style&index=1&id=bf114f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf114f04",
  null
  
)

export default component.exports